// Traductions PayChat — FR / EN
export const translations = {
  fr: {
    // Auth
    app_subtitle: 'Messagerie & Paiements sécurisés',
    login: 'Se connecter',
    logout: 'Déconnexion',
    register: 'Créer un compte',
    phone: 'Téléphone',
    password: 'Mot de passe',
    forgot_password: 'Mot de passe oublié ?',
    send_sms: 'Envoyer le code SMS',
    reset_password: 'Réinitialiser le mot de passe',
    confirm_password: 'Confirmer',
    username: "Nom d'utilisateur",
    display_name: 'Prénom & Nom',
    verify_phone: 'Vérifier mon téléphone',
    code_2fa: 'Code 2FA',
    back: 'Retour',
    loading: 'Chargement...',
    connecting: 'Connexion...',

    // Chat
    messages: 'Messages',
    channels: 'Canaux',
    wallet: 'Wallet',
    profile: 'Profil',
    message_placeholder: 'Message...',
    search_user: 'Rechercher un utilisateur...',
    online: 'En ligne',
    offline: 'Hors ligne',
    seen_at: 'Vu à',
    seen_on: 'Vu le',
    just_now: "À l'instant",
    minutes_ago: 'il y a',
    min: 'min',
    copy: 'Copier',
    reply: 'Répondre',
    forward: 'Transférer',
    delete: 'Supprimer',
    edit: 'Modifier',
    send: 'Envoyer',
    payment: 'Paiement',
    voice_note: 'Vocal',
    photo: 'Photo',
    video: 'Vidéo',
    document: 'Document',
    location: 'Position',
    sticker: 'Sticker',
    take_photo: 'Prendre une photo',
    record_video: 'Filmer une vidéo',
    gallery: 'Photothèque / Galerie',
    share_location: 'Partager ma position',
    typing: 'est en train d\'écrire...',
    call_audio: 'Appel audio',
    call_video: 'Appel vidéo',
    call_incoming: 'Appel entrant',
    call_outgoing: 'Appel en cours...',
    accept: 'Décrocher',
    reject: 'Refuser',
    hangup: 'Raccrocher',
    call_ended: 'Appel terminé',
    call_refused: 'Appel refusé',
    group_create: 'Créer un groupe',
    group_name: 'Nom du groupe',
    add_members: 'Ajouter des membres',
    invite: 'Inviter sur PayChat',
    new_conversation: 'Nouvelle conversation',

    // Wallet
    balance: 'Solde disponible',
    send_money: 'Envoyer',
    receive_money: 'Recevoir',
    recharge: 'Recharger',
    history: 'Historique',
    sent: 'Envoyé',
    received: 'Reçu',
    transactions: 'Transactions',
    amount: 'Montant (FCFA)',
    pin_label: 'Code PIN',
    pin_placeholder: '● ● ● ● ● ●',
    confirm_payment: 'Confirmer',
    send_to: 'Envoyer à',
    payment_success: 'Paiement envoyé !',
    insufficient_balance: 'Solde insuffisant',
    pin_error: 'PIN incorrect',
    min_amount: 'Montant minimum : 100 FCFA',

    // Profile
    my_profile: 'Mon Profil',
    edit_profile: 'Modifier le profil',
    save: 'Enregistrer',
    cancel: 'Annuler',
    change_photo: 'Changer la photo',
    security: 'Sécurité',
    change_password: 'Changer le mot de passe',
    setup_pin: 'Configurer le PIN',
    two_factor: 'Double authentification',
    language: 'Langue',
    french: 'Français',
    english: 'English',
    notifications: 'Notifications',
    privacy: 'Confidentialité',

    // Errors
    error_network: 'Erreur réseau',
    error_server: 'Erreur serveur',
    error_payment: 'Erreur paiement',
    not_connected: 'Non connecté',
    try_again: 'Réessayer',
  },

  en: {
    // Auth
    app_subtitle: 'Secure Messaging & Payments',
    login: 'Sign in',
    logout: 'Sign out',
    register: 'Create account',
    phone: 'Phone',
    password: 'Password',
    forgot_password: 'Forgot password?',
    send_sms: 'Send SMS code',
    reset_password: 'Reset password',
    confirm_password: 'Confirm',
    username: 'Username',
    display_name: 'Full name',
    verify_phone: 'Verify my phone',
    code_2fa: '2FA Code',
    back: 'Back',
    loading: 'Loading...',
    connecting: 'Connecting...',

    // Chat
    messages: 'Messages',
    channels: 'Channels',
    wallet: 'Wallet',
    profile: 'Profile',
    message_placeholder: 'Message...',
    search_user: 'Search a user...',
    online: 'Online',
    offline: 'Offline',
    seen_at: 'Seen at',
    seen_on: 'Seen on',
    just_now: 'Just now',
    minutes_ago: 'ago',
    min: 'min',
    copy: 'Copy',
    reply: 'Reply',
    forward: 'Forward',
    delete: 'Delete',
    edit: 'Edit',
    send: 'Send',
    payment: 'Payment',
    voice_note: 'Voice note',
    photo: 'Photo',
    video: 'Video',
    document: 'Document',
    location: 'Location',
    sticker: 'Sticker',
    take_photo: 'Take a photo',
    record_video: 'Record video',
    gallery: 'Photo library / Gallery',
    share_location: 'Share my location',
    typing: 'is typing...',
    call_audio: 'Audio call',
    call_video: 'Video call',
    call_incoming: 'Incoming call',
    call_outgoing: 'Calling...',
    accept: 'Answer',
    reject: 'Decline',
    hangup: 'Hang up',
    call_ended: 'Call ended',
    call_refused: 'Call declined',
    group_create: 'Create group',
    group_name: 'Group name',
    add_members: 'Add members',
    invite: 'Invite to PayChat',
    new_conversation: 'New conversation',

    // Wallet
    balance: 'Available balance',
    send_money: 'Send',
    receive_money: 'Receive',
    recharge: 'Top up',
    history: 'History',
    sent: 'Sent',
    received: 'Received',
    transactions: 'Transactions',
    amount: 'Amount (FCFA)',
    pin_label: 'PIN code',
    pin_placeholder: '● ● ● ● ● ●',
    confirm_payment: 'Confirm',
    send_to: 'Send to',
    payment_success: 'Payment sent!',
    insufficient_balance: 'Insufficient balance',
    pin_error: 'Incorrect PIN',
    min_amount: 'Minimum amount: 100 FCFA',

    // Profile
    my_profile: 'My Profile',
    edit_profile: 'Edit profile',
    save: 'Save',
    cancel: 'Cancel',
    change_photo: 'Change photo',
    security: 'Security',
    change_password: 'Change password',
    setup_pin: 'Set up PIN',
    two_factor: 'Two-factor auth',
    language: 'Language',
    french: 'Français',
    english: 'English',
    notifications: 'Notifications',
    privacy: 'Privacy',

    // Errors
    error_network: 'Network error',
    error_server: 'Server error',
    error_payment: 'Payment error',
    not_connected: 'Not connected',
    try_again: 'Try again',
  }
,

  pidgin: {
    app_subtitle: 'Messaging & Payment wey safe',
    login: 'Enter', logout: 'Comot', register: 'Make account',
    phone: 'Phone number', password: 'Password', forgot_password: 'You forget password?',
    send_sms: 'Send SMS code', reset_password: 'Reset password', confirm_password: 'Confirm am',
    username: 'Username', display_name: 'Your name', verify_phone: 'Verify phone',
    code_2fa: '2FA code', back: 'Go back', loading: 'E dey load...', connecting: 'E dey connect...',
    messages: 'Messages', channels: 'Channels', wallet: 'Wallet', profile: 'Profile',
    message_placeholder: 'Type message...', search_user: 'Find person...',
    online: 'E dey online', offline: 'E no dey', just_now: 'Just now', minutes_ago: 'ago', min: 'min',
    copy: 'Copy', reply: 'Reply', forward: 'Forward', delete: 'Delete', edit: 'Change am', send: 'Send',
    payment: 'Payment', voice_note: 'Voice', photo: 'Photo', video: 'Video', document: 'Document',
    location: 'Location', sticker: 'Sticker', send_money: 'Send money', receive_money: 'Receive money',
    balance: 'Balance', wallet_balance: 'Wallet balance', transaction_history: 'Transaction history',
    amount: 'Amount', recipient: 'Person wey go receive', confirm_payment: 'Confirm payment',
    payment_success: 'Money don go!', payment_failed: 'Payment no work', enter_pin: 'Enter PIN',
    setup_pin: 'Set PIN', insufficient_balance: 'Money no reach', pin_error: 'PIN no correct',
    min_amount: 'Minimum: 100 FCFA', my_profile: 'My profile', edit_profile: 'Edit profile',
    save: 'Save am', cancel: 'Cancel', change_photo: 'Change photo', security: 'Security',
    change_password: 'Change password', two_factor: 'Two-factor', language: 'Language',
    french: 'Français', english: 'English', notifications: 'Notifications', privacy: 'Privacy',
    error_network: 'Network problem', error_server: 'Server problem', error_payment: 'Payment problem',
    not_connected: 'No connection', try_again: 'Try again',
  },

  fulfulde: {
    app_subtitle: 'Tesko e hokkude ceede to ɓanndu',
    login: 'Naado', logout: 'Yaho', register: 'Siftorde',
    phone: 'Wayti telefon', password: 'Suuɗorgal', forgot_password: 'A yahi suuɗorgal maa?',
    send_sms: 'Neln SMS', reset_password: 'Heɓt suuɗorgal', confirm_password: 'Jaɓɓo',
    username: 'Innde maa', display_name: 'Innde e deftere', verify_phone: 'Jaɓɓin telefon maa',
    code_2fa: 'Lambo 2FA', back: 'Rutto', loading: 'E waɗeede...', connecting: 'E naatneede...',
    messages: 'Teskoji', channels: 'Laabi', wallet: 'Sokoye', profile: 'Hakkunde maa',
    message_placeholder: 'Winnd tesko...', search_user: 'Ŋaar neɗɗo...',
    online: 'E dow retel', offline: 'Waaɗii', just_now: 'Jooni', minutes_ago: 'ko adii', min: 'daqiiqe',
    copy: 'Naatnu', reply: 'Jaaboo', forward: 'Neldu', delete: 'Moƴƴin', edit: 'Waylu', send: 'Neldu',
    payment: 'Hokkude ceede', voice_note: 'Daande', photo: 'Foto', video: 'Video',
    document: 'Takkaré', location: 'Nokku', sticker: 'Natal',
    send_money: 'Neldu ceede', receive_money: 'Heɓ ceede', balance: 'Ceede e sokoye',
    wallet_balance: 'Ceede e sokoye maa', transaction_history: 'Ɗowitaari ceede',
    amount: 'Tonngoode ceede', recipient: 'Neɗɗo heɓotooɗo', confirm_payment: 'Jaɓɓo hokkude ceede',
    payment_success: 'Ceede neldaama!', payment_failed: 'Hokkude ceede yoɓaaki',
    enter_pin: 'Naatnu koodal maa', setup_pin: 'Sett koodal PIN',
    insufficient_balance: 'Ceede ɓuri famɗude', pin_error: 'Koodal horiima', min_amount: 'Famɗudi: 100 FCFA',
    my_profile: 'Hakkunde am', edit_profile: 'Waylu hakkunde', save: 'Dabboo', cancel: 'Haay',
    change_photo: 'Waylu foto', security: 'Suuɗagol', change_password: 'Waylu suuɗorgal',
    two_factor: 'Jaɓɓingol ɗiɗi', language: 'Lamɗam', french: 'Faransiire', english: 'Engele',
    notifications: 'Tindingol', privacy: 'Suuɗagol',
    error_network: 'Coktal retel', error_server: 'Coktal sarwer', error_payment: 'Coktal hokkude ceede',
    not_connected: 'Alaa naatgal', try_again: 'Tott ko adii',
  },

  ewondo: {
    app_subtitle: 'Biana ye fep moni yé asɛ',
    login: 'Dzoe', logout: 'Fep', register: 'Tara dzɔm',
    phone: 'Telefon', password: 'Mot de passe', forgot_password: 'O wul mot de passe?',
    send_sms: 'Tun SMS', reset_password: 'Sɛl mot de passe', confirm_password: 'Sɔŋ',
    username: 'Dzina wô', display_name: 'Dzina ye mbɔk', verify_phone: 'Sɔŋ telefon wô',
    code_2fa: 'Code 2FA', back: 'Sɛ ndzié', loading: 'E yeba...', connecting: 'E yeba...',
    messages: 'Biana', channels: 'Bɛkpwel', wallet: 'Sac moni', profile: 'Mvoe wô',
    message_placeholder: 'Kel biana...', search_user: 'Ndzé mɔt...',
    online: 'E yɔbé', offline: 'E yɔbé a kié', just_now: 'Siés', minutes_ago: 'bi ndzié', min: 'min',
    copy: 'Kɔp', reply: 'Etɔl', forward: 'Tun', delete: 'Kal', edit: 'Sɛl', send: 'Tun',
    payment: 'Fep moni', voice_note: 'Ndzem', photo: 'Foto', video: 'Vidéo',
    document: 'Papier', location: 'Tsie', sticker: 'Mbia',
    send_money: 'Tun moni', receive_money: 'Dze moni', balance: 'Moni e sac',
    wallet_balance: 'Moni wô e sac', transaction_history: 'Bikalé moni',
    amount: 'Bɛ moni', recipient: 'Mɔt a dze moni', confirm_payment: 'Sɔŋ fep moni',
    payment_success: 'Moni etunngé!', payment_failed: 'Fep moni ekié',
    enter_pin: 'Kel code wô', setup_pin: 'Tara code PIN',
    insufficient_balance: 'Moni e kié ke', pin_error: 'Code ekié', min_amount: 'Ndzié: 100 FCFA',
    my_profile: 'Mvoe am', edit_profile: 'Sɛl mvoe', save: 'Dabboo', cancel: 'Bɔl',
    change_photo: 'Sɛl foto', security: 'Bikié', change_password: 'Sɛl mot de passe',
    two_factor: 'Sɔŋ ɗiɗi', language: 'Dzal', french: 'Français', english: 'Anglais',
    notifications: 'Bɛtindé', privacy: 'Bikié',
    error_network: 'Réseau ekié', error_server: 'Serveur ekié', error_payment: 'Fep moni ekié',
    not_connected: 'O yɔbé a kié', try_again: 'Tɛt yété',
  },

  duala: {
    app_subtitle: 'Bwambe ye pɛya mbongo na bɔkɔ',
    login: 'Luka', logout: 'Buka', register: 'Tara nyina',
    phone: 'Telefon', password: 'Mot de passe', forgot_password: 'O wɔl mot de passe?',
    send_sms: 'Tuma SMS', reset_password: 'Lɛmba mot de passe', confirm_password: 'Ndikɛ',
    username: 'Ina wô', display_name: 'Ina na buka', verify_phone: 'Ndikɛ telefon wô',
    code_2fa: 'Code 2FA', back: 'Sɔ na muma', loading: 'E yɛba...', connecting: 'E yɛba...',
    messages: 'Bwambe', channels: 'Njola', wallet: 'Sac mbongo', profile: 'Nyina wô',
    message_placeholder: 'Yɛla bwambe...', search_user: 'Nda moto...',
    online: 'E yɛ na net', offline: 'E yɛ te', just_now: 'Wañañe', minutes_ago: 'bi na muma', min: 'min',
    copy: 'Kopi', reply: 'Sɔsa', forward: 'Tuma', delete: 'Kala', edit: 'Lɛmba', send: 'Tuma',
    payment: 'Pɛya mbongo', voice_note: 'Ndumba', photo: 'Foto', video: 'Video',
    document: 'Papie', location: 'Tsie', sticker: 'Mbɔmbɔ',
    send_money: 'Tuma mbongo', receive_money: 'Hɔpa mbongo', balance: 'Mbongo na sac',
    wallet_balance: 'Mbongo wô na sac', transaction_history: 'Bikalé mbongo',
    amount: 'Bɛ mbongo', recipient: 'Moto a hɔpa mbongo', confirm_payment: 'Ndikɛ pɛya mbongo',
    payment_success: 'Mbongo etumangé!', payment_failed: 'Pɛya mbongo ekié',
    enter_pin: 'Yɛla code wô', setup_pin: 'Tara code PIN',
    insufficient_balance: 'Mbongo e kié ke', pin_error: 'Code ekié', min_amount: 'Ndzié: 100 FCFA',
    my_profile: 'Nyina am', edit_profile: 'Lɛmba nyina', save: 'Pumba', cancel: 'Buka',
    change_photo: 'Lɛmba foto', security: 'Bikié', change_password: 'Lɛmba mot de passe',
    two_factor: 'Ndikɛ ɗiɗi', language: 'Lɔba', french: 'Français', english: 'Anglais',
    notifications: 'Bɛtindé', privacy: 'Bikié',
    error_network: 'Réseau ekié', error_server: 'Serveur ekié', error_payment: 'Pɛya mbongo ekié',
    not_connected: 'O yɛ te na net', try_again: 'Tɛt yété',
  },

  ghomala: {
    app_subtitle: 'Pɔ tso nə sɛ nkap nə pɔ kwa',
    login: 'Tso', logout: 'Yɔ', register: 'Tara',
    phone: 'Tɛlɛfɔn', password: 'Mot de passe', forgot_password: 'O wul mot de passe?',
    send_sms: 'Tum SMS', reset_password: 'Sɛl mot de passe', confirm_password: 'Ndik',
    username: 'Dzi wô', display_name: 'Dzi nə bɔ', verify_phone: 'Ndik tɛlɛfɔn wô',
    code_2fa: 'Code 2FA', back: 'Sɔ nə mum', loading: 'E yɛba...', connecting: 'E yɛba...',
    messages: 'Bitso', channels: 'Bikpwel', wallet: 'Sak nkap', profile: 'Tara wô',
    message_placeholder: 'Yɛl bitso...', search_user: 'Nda mɔt...',
    online: 'E yɛ nɛt', offline: 'E yɛ tɛ', just_now: 'Sies', minutes_ago: 'bi nə mum', min: 'min',
    copy: 'Kɔpi', reply: 'Sɔsɔ', forward: 'Tum', delete: 'Kpal', edit: 'Sɛl', send: 'Tum',
    payment: 'Sɛ nkap', voice_note: 'Ndzɛm', photo: 'Foto', video: 'Video',
    document: 'Takrit', location: 'Tsie', sticker: 'Mbia',
    send_money: 'Tum nkap', receive_money: 'Hɔp nkap', balance: 'Nkap nə sak',
    wallet_balance: 'Nkap wô nə sak', transaction_history: 'Bikalé nkap',
    amount: 'Bɛ nkap', recipient: 'Mɔt a hɔp nkap', confirm_payment: 'Ndik sɛ nkap',
    payment_success: 'Nkap etumngé!', payment_failed: 'Sɛ nkap ekié',
    enter_pin: 'Yɛl code wô', setup_pin: 'Tara code PIN',
    insufficient_balance: 'Nkap e kié', pin_error: 'Code ekié', min_amount: 'Ndzié: 100 FCFA',
    my_profile: 'Tara am', edit_profile: 'Sɛl tara', save: 'Pumba', cancel: 'Buka',
    change_photo: 'Sɛl foto', security: 'Bikié', change_password: 'Sɛl mot de passe',
    two_factor: 'Ndik diɗi', language: 'Lɔba', french: 'Français', english: 'Anglais',
    notifications: 'Bɛtindé', privacy: 'Bikié',
    error_network: 'Réseau ekié', error_server: 'Serveur ekié', error_payment: 'Sɛ nkap ekié',
    not_connected: 'O yɛ tɛ nɛt', try_again: 'Tɛt yété',
  }
};

export default translations;
